<template>
  <div class="yunshubbToggle">
    <div class="yunshubb_form" style="position: relative" v-loading = "loading">
      <div
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>
      <div class="ysbb">
        <img
          src="@/assets/img/ysbb.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <el-form
          ref="ysbbForm"
          label-position="right"
          :model="ysbbForm"
          label-width="130px"
          :rules="rules"
        >
          <el-form-item label="运输许可证:" class="is-required" prop="yszBh">
            <el-input
              v-model="ysbbForm.yszBh"
              disabled
              style="width: calc(100% - 75px)"
            />
            <el-button
              v-preventReClick
              :disabled="ckdisable || bgdisable"
              type="primary"
              class="xuanze"
              @click="ysxkzTk"
            >选择</el-button>
          </el-form-item>
          <el-form-item label="化学品:" class="is-required" prop="hxpMc">
            <el-input v-model="ysbbForm.hxpMc" disabled />
          </el-form-item>
          <el-form-item label="起运数量:" class="is-required" prop="qysl">
            <el-input
              v-model="ysbbForm.qysl"
              type="number"
              :disabled="ckdisable"
              style="width: 65%"
              placeholder="请输入起运数量"
            />
            <el-select
              v-model="ysbbForm.qyslDw"
              :disabled="ckdisable"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
              @change="hqydwchange"
            >
              <el-option
                v-for="(item, index) in ckslList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="抵达数量:" class="is-required" prop="ddsl">
            <el-input
              v-model="ysbbForm.ddsl"
              type="number"
              :disabled="ckdisable"
              style="width: 65%"
              placeholder="请输入"
            />
            <el-input
              v-model="ysbbForm.ddslDwMc"
              disabled
              type="text"
              style="width: calc(35% - 10px); hight: 100%; margin-left: 10px"
            />
            <!-- <el-select
              :disabled="ckdisable"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
              v-model="ysbbForm.qyslDw"
              class="is-required"
            >
              <el-option
                v-for="(item, index) in ckslList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item
            v-if="childrenType == '查看'"
            label="损耗数量:"
            prop="shslDw"
          >
            <el-input
              v-model="ysbbForm.shsl"
              :disabled="ckdisable || bgdisable"
              style="width: 65%"
              placeholder="请输入"
              @input="hshsl"
            />
            <el-select
              v-model="ysbbForm.shslDw"
              :disabled="ckdisable || bgdisable"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
            >
              <el-option
                v-for="(item, index) in ckslList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="childrenType == '查看'" label="损耗率:">
            <el-input
              v-model="ysbbForm.shl2"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="损耗原因:" prop="shyy">
            <el-input
              v-model="ysbbForm.shyy"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item
            label="发货单位统一社会信用代码:"
            class="is-required"
            label-width="195px"
            prop="fhdwTyshxydm"
          >
            <el-input
              v-model="ysbbForm.fhdwTyshxydm"
              disabled
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="发货单位:" class="is-required" prop="fhdw">
            <el-input
              v-model="ysbbForm.fhdw"
              disabled
              placeholder="请输入发货单位"
            />
          </el-form-item>
          <el-form-item
            label="承运单位统一社会信用代码:"
            class="is-required"
            label-width="195px"
            prop="ysdwTyshxydm"
          >
            <el-input
              v-model="ysbbForm.ysdwTyshxydm"
              disabled
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="承运单位:" class="is-required" prop="cydw">
            <el-input
              v-model="ysbbForm.cydw"
              disabled
              placeholder="请输入承运单位"
            />
          </el-form-item>
          <el-form-item label="运输方式:" class="is-required" prop="ysfs">
            <el-select
              v-model="yunshufangshi"
              :disabled="ckdisable || bgdisable"
              multiple
              style="width: 100%"
              placeholder="请选择"
              @change="hyunshufangshi"
            >
              <el-option
                v-for="(item, index) in yunshuLish"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="运输车号/次:"
            class="is-required"
            prop="hc"
            style="position: relative"
          >
            <el-input
              v-model="ysbbForm.hc"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入运输车号/次"
            />
            <div
              style="
                position: absolute;
                right: 2px;
                top: 0;
                cursor: pointer;
                font-size: 20px;
                color: #5b96ee;
                height: 30;
                width: 40px;
                background: white;
                margin-top: 4px;
                text-align: center;
                line-height: 30px;
              "
              :title="ysbbForm.hc"
            >
              <i class="el-icon-more" />
            </div>
          </el-form-item>
          <el-form-item
            label="收货单位统一社会信用代码:"
            class="is-required"
            label-width="195px"
            prop="shdwTyshxydm"
          >
            <el-input
              v-model="ysbbForm.shdwTyshxydm"
              disabled
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="收货单位:" class="is-required" prop="shdw">
            <el-input
              v-model="ysbbForm.shdw"
              disabled
              placeholder="请输入收货单位"
            />
          </el-form-item>
          <el-form-item label="购买许可证:">
            <el-input
              v-model="ysbbForm.gmzBh"
              :disable="ckdisable || bgdisable"
              placeholder="请输入"
              disabled
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="运输日期:" class="is-required" prop="ysrq">
            <el-date-picker
              v-model="ysbbForm.ysrq"
              :picker-options="pickerBeginDateBefore"
              :disabled="ckdisable"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="经办人" prop="jbrxm">
            <el-select
              v-model="ysbbForm.jbrxm"
              filterable
              style="width: 100%"
              placeholder="请选择"
              :disabled="ckdisable || bgdisable"
              @change="hjbrChange"
            >
              <el-option
                v-for="item in jingbanrenlist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="登记人:" class="is-required">
            <el-input
              v-model="djr"
              :disable="ckdisable || bgdisable"
              placeholder="请输入"
              disabled
            />
          </el-form-item>
          <el-form-item v-if="djsjshow" label="登记时间:" class="is-required">
            <el-input v-model="djsj" placeholder="选择日期" disabled />
          </el-form-item>
          <el-form-item v-else label="登记时间:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="备注:" style="width: 100%" prop="bz">
            <el-input
              v-model="ysbbForm.bz"
              :disabled="ckdisable || bgdisable"
              placeholder="请输入"
            />
          </el-form-item>

          <el-form-item
            v-if="childrenType == '变更'"
            label="变更理由:"
            style="width: 100%"
            prop="bgly"
          >
            <el-input v-model="ysbbForm.bgly" placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div
          v-if="childrenType == '新增' || childrenType == '编辑'"
          class="footer"
        >
          <el-button v-preventReClick @click="htjbg">暂时保存</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="confirm"
          >报备</el-button>
        </div>
        <!-- 查看 -->
        <div v-if="childrenType == '查看'" class="backButton">
          <el-button
            type="primary"
            @click="$emit('close-dialog')"
          >确定</el-button>
        </div>
        <!-- 变更 -->
        <div v-if="childrenType == '变更'" class="backButton">
          <el-button
            v-preventReClick
            type="primary"
            @click="zsSave"
          >提交变更</el-button>
        </div>
      </div>
    </div>
    <div
      v-if="curRowObj.bgcs > 0"
      style="
        width: 90%;
        max-width: 1195px;
        background-color: white;
        margin: auto;
        margin-top: 10px;
      "
    >
      <div style="width: 90%; padding-top: 20px; margin: auto">
        <img src="../../assets/img/bgsp/ckbg.png" alt="" srcset="">
      </div>
      <bgcsOfDetail
        style="
          width: 90%;
          max-width: 1195px;
          background-color: white;
          margin: auto;
          padding-top: 20px;
          padding-bottom: 10px;
        "
        :cur-row-obj="curRowObj"
        :cur-type="curType"
        :bgcs-t-k-name="'disShow'"
        @bacsCkXqShow="bacsCkXqShow"
      />
    </div>
    <!-- 证件弹框 -->
    <el-dialog title="" :visible.sync="dialogVisible" center>
      <div>
        <el-form
          class="t_search_form"
          style="margin-left: auto; margin-right: auto"
          label-position="center"
          label-width="90px"
        >
          <el-form-item label="运输证编号:">
            <el-input
              v-model="bgform.param.xkzBh"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-button
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
        </el-form>
        <el-table
          ref="xsckTable"
          :data="tableData"
          :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
          border
          :show-overflow-tooltip="true"
          style="
            width: 100%;
            border-left: 1px solid #f4f4f4;
            border-right: 1px solid #f4f4f4;
          "
          :header-cell-class-name="cellClass"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column
            v-for="(item, i) in table2"
            :key="i"
            :show-overflow-tooltip="true"
            align="center"
            :label="item.label"
            :prop="item.key"
          >
            <template slot-scope="scope">
              <span :title="scope.row[item.key]">
                {{
                  item.key == "hzsl"
                    ? scope.row[item.key] + scope.row["hzslDwMc"]
                    : scope.row[item.key]
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :page-sizes="[10, 20, 30, 40]"
        :total="total"
        :page-size="bgform.size"
        class="el-page"
        @size-change="pagesizeChange"
        @current-change="handleCurrentChange"
      />
      <div slot="footer">
        <el-button
          @click="dialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="hquedingTK"
        >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 变更次数详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        :bgcs-t-k-name="bgcsTKName"
        :dgcs-xq-id="dgcsXqId"
        :xq-type="curType"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bgxqCom from '../bgxq/bgxqCom.vue'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import {
  APIysbbtableData, // 购买运输证 弹框数据
  APIhqyszXq, // 运输证详情信息
  APIjingbanren, // 经办人
  APIysbbXzZc, // 新增 暂存
  APIysbbXzZc1,
  APIysbbXiangqign, // 获取详情
  APIysbbbiangeng, APIysbbXzZc1Temp, APIysbbXzZcTemp // 变革
} from '@/assets/js/wangshuai.js'

import { getkv, userInfofLogin } from '@/assets/js/common.js'
import { gethqdw } from '@/assets/js/ccgl.js'
import { lengthValidate } from '@/assets/js/validate.js'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: ['djsjshow', 'ckdisable', 'bgdisable', 'childrenType', 'xkzBh'],
  data() {
    // 抵达数量
    const ddsl_validate = (rule, value, callback) => {
      if (!(this.ysbbForm.ddsl + '')) {
        return callback(new Error('请填写抵达数量值'))
      }

      // if (this.ysbbForm.ddsl < 0) {
      //   return callback(new Error("请填写不小于0的抵达数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!this.bgdisable && !reg.test(this.ysbbForm.ddsl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      }
      if (/^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.ysbbForm.ddslDwMc) {
        return callback(new Error('请选择抵达数量单位'))
      }
      callback()
    }
    // 起运数量
    const qysl_validate = (rule, value, callback) => {
      if (!(this.ysbbForm.qysl + '')) {
        return callback(new Error('请填写起运数量值'))
      }
      if (!this.bgdisable && this.ysbbForm.qysl < 0) {
        return callback(new Error('请填写不小于0的起运数量值'))
      }
      if (/^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.ysbbForm.qyslDw) {
        return callback(new Error('请选择起运数量单位'))
      }
      callback()
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '运输报备',
      bgwindow: false,
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },

      // 弹框校验
      rules: {
        // 输入框
        bz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 2000)
            },
            trigger: ['blur', 'change']
          }
        ],
        yszBh: [{ required: true, message: '请输入', trigger: 'blur' }],
        shyy: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 2000)
            },
            trigger: ['blur', 'change']
          }
        ],
        hxpMc: [{ required: true, message: '请输入', trigger: 'blur' }],
        qysl: [
          {
            required: true,
            validator: qysl_validate,
            trigger: ['blur', 'change']
          }
        ],
        fhdwTyshxydm: [{ required: true, message: '请输入', trigger: 'blur' }],
        fhdw: [{ required: true, message: '请输入', trigger: 'blur' }],
        ysdwTyshxydm: [{ required: true, message: '请输入', trigger: 'blur' }],
        cydw: [{ required: true, message: '请输入', trigger: 'blur' }],
        hc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 2000)
            },
            trigger: ['blur', 'change']
          }
        ],
        shdwTyshxydm: [{ required: true, message: '请输入', trigger: 'blur' }],
        shdw: [{ required: true, message: '请输入', trigger: 'blur' }],
        bgly: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        ddsl: [
          {
            required: true,
            validator: ddsl_validate,
            trigger: ['blur', 'change']
          }
        ],
        // 下拉框
        shslDw: [
          {
            required: false,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        jbrxm: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        ysrq: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        ysfs: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ]
      },
      pickerVal: [],
      // 页面数据
      ysbbForm: {
        bgly: '',
        id: '',
        yszId: '',
        yszBh: '',
        gmzId: '',
        gmzBh: '',
        hxpBm: '',
        hxpMc: '',
        qysl: '',
        qyslDw: '',
        shsl: '',
        shslDw: '',
        shl2: '',
        shyy: '',
        ysrq: '',
        bz: '',
        zt: '',
        fhdw: '',
        fhdwTyshxydm: '',
        cydw: '',
        ysdwTyshxydm: '',
        shdw: '',
        shdwTyshxydm: '',
        ysfs: '', // 运输方式 字典yzd_ysfs 可多选
        ysfsmc: '', // 运输方式名称
        jbr: '', // 经办人
        jbrxm: '', // 经办人姓名
        hc: '',
        ddsl: '',
        ddslDw: '',
        ddslDwMc: ''
      },
      djr: '',
      djsj: '',
      yunshufangshi: [],
      // 运输证
      dialogVisible: false,
      tableData: [],
      table2: [
        {
          key: 'xkzBh',
          label: '许可证编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'hzsl',
          label: '运输数量'
        },
        {
          key: 'fhdwMc',
          label: '发货单位'
        },
        {
          key: 'sqsj',
          label: '申请时间'
        }
      ],
      bgform: {
        page: 1,
        size: 10,
        param: { xkzBh: '' }
      },
      total: 0,

      andleSelectionChangeData_obj: {},
      andleSelectionChangeData_id: 0,
      // 单位下拉
      ckslList: [],
      yunshuLish: [],
      jingbanrenlist: [], // 经办人下拉
      hshslShow: false // 判断是否校验损耗数量单位
    }
  },
  beforeDestroy() {
    this.$bus.$off('fatherToChil')
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('fatherToChil', this.initCon)
    })
    this.htableData()
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })
    getkv('yzd_ysfs').then((res) => {
      this.yunshuLish = res.data.data
    })
    // 获取下拉经办人
    APIjingbanren().then((res) => {
      this.jingbanrenlist = res.data.data
    })

    // this.$refs.ysbbForm.resetFields();

    if (this.xkzBh) {
      this.ysbbForm.yszBh = this.xkzBh
      this.hquedingTK()
    }
    setTimeout(() => {
      this.$refs.ysbbForm.clearValidate()
    }, 30)
  },
  methods: {
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
    },
    hqydwchange(data) {
      this.ckslList.forEach((item) => {
        if (item.value == data) {
          this.ysbbForm.ddslDw = item.value
          this.ysbbForm.ddslDwMc = item.label
        }
      })
    },
    hshsl(val) {
      if (!val) {
        this.$refs.ysbbForm.rules.shslDw[0].required = false
        this.hshslShow = false
      } else {
        this.$refs.ysbbForm.rules.shslDw[0].required = true
        this.hshslShow = true
      }
    },
    // 获取详情
    hhuoquxiangqing(id) {
      APIysbbXiangqign(id).then((res) => {
        this.ysbbForm = res.data.data
        // this.ysbbForm.shl2 =
        // this.ysbbForm.shl2 == 0 ? 0 : this.ysbbForm.shl2 + "%";
        this.yunshufangshi = res.data.data.ysfs
        this.ysbbForm.qyslDw = res.data.data.qyslDw
        this.ysbbForm.shslDw = res.data.data.shslDw
        this.ysbbForm.ddslDwMc = res.data.data.qyslDwMc
        this.djsj = res.data.data.djsj

        const obj = res.data.data.ysfsmc.split(',')
        this.yunshufangshi = []
        obj.forEach((e) => {
          this.yunshuLish.forEach((item) => {
            if (e == item.label) {
              this.yunshufangshi.push(item.value)
            }
          })
        })
        if(res.data.data.hxpBm){
          gethqdw(res.data.data.hxpBm).then((res) => {
            this.ckslList = res.data.data
          })
        }
        this.$nextTick(() => {
          this.$refs.ysbbForm.clearValidate() //清楚页面所有校验结果
        })
      })
    },
    // 选择经办人
    hjbrChange(data) {
      this.jingbanrenlist.forEach((item) => {
        if (data == item.value) {
          this.ysbbForm.jbrxm = item.label
          this.ysbbForm.jbr = item.value
        }
      })
    },
    hyunshufangshi(data) {
      this.ysbbForm.ysfs = ''
      this.ysbbForm.ysfsmc = ''
      data.forEach((item) => {
        this.yunshuLish.forEach((e, k) => {
          if (e.value == item) {
            this.ysbbForm.ysfsmc += e.label + ','
            this.ysbbForm.ysfs += e.value + ','
          }
        })
      })
    },
    // 确定运输证弹框
    hquedingTK() {
      if (this.andleSelectionChangeData_obj == {} && !this.xkzBh) {
        this.$message.error('请选择')
        return
      }
      var data = ''
      if (this.xkzBh) {
        data = this.xkzBh
        this.dialogVisible = false
      } else {
        data = this.andleSelectionChangeData_obj.xkzBh
        this.dialogVisible = false
      }
      APIhqyszXq(data).then((res) => {
        this.ysbbForm.ysdwTyshxydm = res.data.data.cydwTyshxydm
        this.ysbbForm.cydw = res.data.data.cydw
        this.ysbbForm.fhdw = res.data.data.fhdw
        this.ysbbForm.fhdwTyshxydm = res.data.data.fhdwTyshxydm
        this.ysbbForm.gmzBh = res.data.data.gmzBh
        this.ysbbForm.gmzId = res.data.data.gmzId
        // this.ysbbForm.hc = res.data.data.hc;
        this.ysbbForm.hxpBm = res.data.data.hxpBm
        this.ysbbForm.hxpMc = res.data.data.hxpMc
        this.ysbbForm.shdw = res.data.data.shdw
        this.ysbbForm.shdwTyshxydm = res.data.data.shdwTyshxydm
        this.ysbbForm.yszBh = res.data.data.yszBh
        this.ysbbForm.yszId = res.data.data.yszId
        if(res.data.data.hxpBm){
          gethqdw(res.data.data.hxpBm).then((res) => {
            this.ckslList = res.data.data
          })
        }
        this.$refs.ysbbForm.clearValidate(['yszBh','hxpMc','fhdwTyshxydm','fhdw','ysdwTyshxydm','cydw','shdwTyshxydm','shdw'])
      })
    },
    // 获取运输报备弹框内容
    async htableData() {
      this.bgform.param.vdata = await dealDataGy()
      APIysbbtableData(this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    // 内部分页方法
    pagesizeChange(val) {
      this.bgform.size = val
      // 2022/1/6@y添加
      this.htableData()
    },
    handleCurrentChange(val) {
      this.bgform.page = val
      // 2022/1/6@y添加
      this.htableData()
    },
    // 删除全选按钮
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    // 运输证弹框
    ysxkzTk() {
      this.dialogVisible = true
      this.bgform.param.xkzBh = ''
      this.htableData()
    },
    // 购买证运输证单选
    handleSelectionChange(val) {
      if (val.length !== 0) {
        this.andleSelectionChangeData_id = val[0].id
        this.andleSelectionChangeData_obj = val[0]
      }
      if (val.length > 1) {
        this.$refs.xsckTable.clearSelection()
        this.$refs.xsckTable.toggleRowSelection(val.pop())
      }
    },

    // 暂存
    async htjbg() {
      this.ysbbForm.zt = '00'
      // add
      if (!this.ysbbForm.id) {
        this.loading = true
        this.ysbbForm.vdata = await dealDataGy()
        APIysbbXzZcTemp(this.ysbbForm).then((res) => {
          this.loading = false
          this.$emit('close-dialog')
          // this.$parent.hchongzhi();
          this.$parent.htableDataList()
        }).catch((error) => {
          this.loading = false
        })
      }
      // edit
      else {
        this.loading = true
        APIysbbXzZc1Temp(this.ysbbForm).then((res) => {
          this.loading = false
          this.$emit('close-dialog')
          // this.$parent.hchongzhi();
          this.$parent.htableDataList()
        }).catch((error) => {
          this.loading = false
        })
      }
    },
    back() {
      this.$parent.xkzBh = ''
      this.$emit('close-dialog')
    },
    zsSave() {
      this.$refs.ysbbForm.validate((valid) => {
        if (valid) {
          const obj = {
            id: this.ysbbForm.id,
            qysl: this.ysbbForm.qysl,
            qyslDw: this.ysbbForm.qyslDw,
            shsl: this.ysbbForm.shsl,
            shslDw: this.ysbbForm.shslDw,
            ysrq: this.ysbbForm.ysrq,
            bgly: this.ysbbForm.bgly,
            ddsl: this.ysbbForm.ddsl,
            ddslDw: this.ysbbForm.qyslDw
          }
          this.loading = true
          APIysbbbiangeng(obj).then((res) => {
            this.loading = false
            this.$emit('close-dialog')
            this.$parent.htableDataList()
          }).catch((error) => {
            this.loading = false
          })
        }
      })
    },
    // 报备
    confirm() {
      this.$refs.ysbbForm.validate(async (valid) => {
        if (valid) {
          this.ysbbForm.zt = '01'
          if (!this.ysbbForm.id) {
            this.loading = true
            this.ysbbForm.vdata = await dealDataGy()
            APIysbbXzZc(this.ysbbForm).then((res) => {
              this.loading = false
              this.$emit('close-dialog')
              // this.$parent.hchongzhi();
              this.$parent.htableDataList()
            }).catch((error) => {
              this.loading = false
            })
          } else {
            this.loading = true
            APIysbbXzZc1(this.ysbbForm).then((res) => {
              this.loading = false
              this.$emit('close-dialog')
              // this.$parent.hchongzhi();
              this.$parent.htableDataList()
            }).catch((error) => {
              this.loading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.yunshubbToggle {
  padding-top: 10px;
  .yunshubb_form {
    width: 90%;
    max-width: 1195px;
    background-color: white;
    margin: auto;

    .ysbb {
      width: 90%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
      }
    }
    .xuanze {
      margin-left: 10px;
      color: #ffffff;
      width: 65px;
      height: 39px;
      background: #4170ff;
      border-radius: 2px;
    }
  }
  .footer {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 45px;
    display: flex;
    justify-content: center;
    .el-button:nth-child(1) {
      margin-right: 195px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .el-button:nth-child(2) {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
}
.backButton {
  width: 148px;
  margin: 30px auto 40px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}

/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"] {
  -moz-appearance: textfield;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
</style>
